var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',_vm._l((_vm.links),function(link){return _c(_vm.renderComponent,{key:link,tag:"component",staticClass:"mr-1",attrs:{"href":'/dialogkontrolle/' + link,"to":'/dialogkontrolle/' + link}},[_vm._v("\n    "+_vm._s(link)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }